import { render } from "./Duvidas.vue?vue&type=template&id=df0f66a4&scoped=true"
import script from "./Duvidas.vue?vue&type=script&lang=js"
export * from "./Duvidas.vue?vue&type=script&lang=js"

import "./Duvidas.vue?vue&type=style&index=0&id=df0f66a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df0f66a4"]])

export default __exports__